module.exports = __webpack_public_path__ + "img/国徽面.5b71c92e.png";